import { render } from "./AccommodationItem.vue?vue&type=template&id=1693d081&scoped=true&class=comp"
import script from "./AccommodationItem.vue?vue&type=script&lang=js"
export * from "./AccommodationItem.vue?vue&type=script&lang=js"

import "./AccommodationItem.vue?vue&type=style&index=0&id=1693d081&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1693d081"]])

export default __exports__